import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { Draggablemodal1Component } from '../draggablemodal1/draggablemodal1.component';
import { DatePipe } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-draggablemodal3',
  templateUrl: './draggablemodal3.component.html',
  styleUrls: ['./draggablemodal3.component.scss'],

})
export class Draggablemodal3Component implements OnInit {
  public datechange:any;
  constructor(public activeModal: NgbActiveModal,private service: ApifirstService,private modalService: NgbModal,public translate: TranslateService, public datePipe: DatePipe) { }
test1:any;
test2:any;
language:any;
setDate: any; // Date which is set to local storage for 24hrs checking customer consent popup 
currentDate: any; 
formattedDate: any;
vinNumber: any;
tokenObjRes: any;
public vinArray: string[] = [];

    ngOnInit(): void {
      this.test1=this.translate.instant('CONSENT DECLINED');
      this.test2=this.translate.instant('CONSENT PROVIDED');
      this.service.tokenObj.subscribe(data=>{
        let c:any =data
      this.language=c.language
    })
      $(document).ready(function(){
        let modalContent: any = $('.modal-content');
       
        modalContent.draggable({
        handle: '#full-width1'
        });
      });
      if (!$(".modal.in").length) {
        $(".modal-dialog").css({
          top: 100,
          left: 0,        
        });
      }
    

    }

    openModal1(){

      this.setDate = new Date()
      this.formattedDate =  this.datePipe.transform(this.setDate, 'yyyy-MM-dd hh:mm');
      window.localStorage.setItem("setcustomerConcentDate", this.formattedDate);

      this.service.tokenObj.subscribe((data) => {
        this.tokenObjRes = data;
        this.vinNumber = this.tokenObjRes.vin;
      })
      this.vinArray.push(this.vinNumber + ',');
      var strArray = this.vinArray.toString();
      var items = localStorage.getItem('VINnumber')
      if(items != null) {
        var arr = items.split(",")
        if(!arr.includes(this.vinNumber)) {
          this.vinArray.push(items)
          var convertStrArray = this.vinArray.toString()
          window.localStorage.setItem('VINnumber', convertStrArray);
        }
      } else {
        window.localStorage.setItem('VINnumber', strArray);
      }
      


      const modalRef = this.modalService.open(Draggablemodal1Component, { windowClass : "myCustomModalClass",
      backdrop: 'static'
        });
        modalRef.result.then(
            result => {
                console.log(result);
            },
            reason => {}
       )
    
   }

  }

